<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.program.contactList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <button class="btn btn-dark" @click="$router.go(-1)">
                    <span class="fa fa-caret-left"></span>
                    <span class="fa fa-caret-left"></span>
                </button>

                <hr />

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-sm-9 mx-auto">
                        <div class="card py-5 px-2" style="min-height: 820px">
                            <div class="card-body">
                                <p class="text-center">
                                    <small>{{$t('app.name')}}</small>
                                </p>

                                <div class="logo text-right my-5">
                                    <img src="/logo/sbs_transp.png" alt="SBS Logo" style="height: 65px" />
                                </div>

                                <h2 class="d-inline">{{$t('form.program.contactList')}}</h2>

                                <div class="float-right">
                                    <form action="#" v-if="notToShow==0">
                                        <div class="form-group">
                                            <label>{{$t('form.program.selectContactList')}}</label>
                                            <v-select  label="name" :options="contactList" v-model="selectedListId"
                                                :reduce="contactList => contactList.listid">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                <input type="checkbox" @change="syncStudents($event)" />
                                                {{$t('form.program.synchronizeStudents')}}
                                            </label>
                                        </div>
                                    </form>
                                    <label v-else-if="notToShow==1">{{$t('form.program.selectContactListEmpty')}}</label>
                                </div>

                                <div class="table-responsive p-0">
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th colspan="2">{{program.ProgramTitle}} {{$t('form.program.program')}},
                                                    {{program.AcademicYear | year}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(student,index) in students" v-bind:key="index">
                                                <td>{{student.FirstName}} {{student.LastName}}</td>
                                                <td>
                                                    <a
                                                        :href="`mailto:${$options.filters.email(student)}`">{{student | email}}</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                    @paginate="paginate()"></pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["permissions"],

        data() {
            return {

                isLoading: false,
                fullPage: true,

                alert: false,
                alertClass: '',
                alertMessage: '',

                pagination: {
                    current_page: 1
                },

                selectedListId: 0,

                program: {},
                students: [],
                contactList: [],
                 
                notToShow:0, 
            }
        },

        mounted() {
            if (!this.permissions.viewStudentsContacts) {
                this.$router.push('/');
                return;
            }

            this.getStudents();
            this.getContactList();
        },

        filters: {
            year(date) {
                return moment(date).format('YYYY');
            },
            email(student) {
                return student.MailAddress == 2 ? student.business?student.business.Email:null : student.Email;
            }
        },

        methods: {
            showAlert(msg, cls = 'success') {
                this.alertClass = cls;
                this.alertMessage = msg;
                this.alert = true;
            },

            syncStudents(event) {
                let pID = this.$route.params.id;

                if (!pID || !event.target.checked) return;

                if (!this.selectedListId) {
                    this.showAlert(this.$t('form.validation.selectContactList'), 'danger');
                    event.target.checked = false;
                    return;
                }

                this.isLoading = true;

                axios
                    .put(`/api/sync-students/${pID}`, {
                        listid: this.selectedListId
                    })
                    .then(response => {
                        this.showAlert(response.data.message);

                        this.isLoading = false;
                    })
                    .catch(error => {
                        // console.log(error.response);

                        this.isLoading = false;
                    });
            },

            getStudents() {
                let pID = this.$route.params.id;

                if (!pID) return;

                this.isLoading = true;

                if(this.$route.path.includes('alumni/')){
                    axios
                    .get(`/api/programs/${pID}/alumni?page=${this.pagination.current_page}&include=business`)
                    .then(response => {
                        let data = response.data;

                        this.program = data.program;
                        this.students = data.students.data.data;
                        this.pagination = data.students.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response);

                        this.isLoading = false;
                    });
                }else if(this.$route.path.includes('student/')){
                    axios
                    .get(`/api/programs/${pID}/students?page=${this.pagination.current_page}&include=business`)
                    .then(response => {
                        let data = response.data;                    

                        this.program = data.program;
                        this.students = data.students.data.data;
                        this.pagination = data.students.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log(error.response);

                        this.isLoading = false;
                    });
                        }

                
            },

            getContactList() {
                axios
                    .get('/api/sync-contact-list')
                    .then(response => {
                        this.contactList = response.data;
                        if(typeof this.contactList=='string'){
                          this.notToShow = 1;
                        }
                    })
                    .catch(error => console.log(error.response));
            },

            paginate() {
                this.getStudents();
            }
        }
    };

</script>

<style scoped></style>
